import { ButtonSecondary } from "@/shared/components/atoms/ButtonSecondary";
import { t } from "i18next";
import { FC } from "react";

export const PagesNotFound: FC<any> = () => {
  return (
    <>
      {/*
    This example requires updating your template:

    ```
    <html class="h-full">
    <body class="h-full">
    ```
  */}
      <main className="relative isolate min-h-full">
        <img
          alt=""
          src="https://images.unsplash.com/photo-1545972154-9bb223aac798?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=3050&q=80&exp=8&con=-15&sat=-75"
          className="absolute inset-0 -z-10 h-full w-full object-cover object-top"
        />
        <div className="mx-auto max-w-7xl px-6 py-6 text-center lg:px-8 ">
          <p className="text-base font-semibold leading-8 text-white">404</p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-white sm:text-5xl">
            {t("user.views.page_not_found")}
          </h1>
          <p className="mt-4 text-base text-white/70 sm:mt-6">
            {t("user.views.page_not_found_description_one")}
          </p>
          <p className="mt-4 text-base text-white/70 sm:mt-6">
            {t("user.views.page_not_found_description_two")}
          </p>
        </div>

        <div className="flex flex-col items-center">
          <div className="w-11/12 sm:w-7/12 md:w-6/12 lg:w-5/12 py-2 xl:overflow-visible xl:whitespace-nowrap">
            <p className="text-base text-white/70 mt-6">
              1.{" "}
              <span className="font-bold">
                {t("user.views.page_not_found_description_three_one")}{" "}
              </span>
              {t("user.views.page_not_found_description_three_two")}
            </p>
            <p className=" text-base text-white/70 mt-2">
              2. {t("user.views.page_not_found_description_four_one")}{" "}
              <span className="font-bold">
                {t("user.views.page_not_found_description_four_two")}{" "}
              </span>
              {t("user.views.page_not_found_description_four_three")}
            </p>
          </div>
        </div>

        <div className="mx-auto max-w-7xl px-6 pb-6 text-center lg:px-8">
          <div className="mt-10 flex justify-center">
            <a href="#" className="text-sm font-semibold leading-7 text-white">
              <span aria-hidden="true">&larr;</span>{" "}
              {t("user.views.page_not_found_description_three_one")}
            </a>
          </div>

          <p className="mt-4 text-base text-white/70 sm:mt-10">
            {t("user.views.page_not_found_description_five")}
          </p>
          {/* Añade más items aquí */}
        </div>

        <div className="flex flex-col items-center">
          <div className="bg-gray-800/50 w-11/12 sm:w-6/12 md:w-5/12 lg:w-4/12 py-2 mt-12">
            <p className="relative text-base font-semibold text-white -mt-10">
              {t("user.views.information_error")}:
            </p>
            <ul className="space-y-2 flex flex-col px-4 mt-4">
              <li className="flex items-center gap-2 text-base text-white/70">
                <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300" />{" "}
                <span className="font-semibold">
                  {t("user.views.id_branchs")}
                </span>{" "}
                17
              </li>
              <li className="flex items-center gap-2 text-base text-white/70">
                <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300" />{" "}
                <span className="font-semibold">
                  {" "}
                  {t("user.views.id_user_login")}
                </span>{" "}
                2233
              </li>
              <li className="flex items-center gap-2 text-base text-white/70">
                <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300" />{" "}
                <span className="font-semibold">
                  {t("user.views.id_attempt_access")}{" "}
                </span>{" "}
                2233
              </li>
              <li className="flex items-center gap-2 text-base text-white/70">
                <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300" />{" "}
                <span className="font-semibold">{t("user.views.error")}</span>{" "}
                ERROR AL AGREGAR USUARIO
              </li>
              <li className="flex items-center gap-2 text-base text-white/70">
                <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300" />{" "}
                <span className="font-semibold">
                  {t("user.views.datetime_server")}
                </span>{" "}
                17-10-2024
              </li>
              <li className="flex items-center gap-2 text-base text-white/70">
                <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300" />{" "}
                <span className="font-semibold">
                  {t("user.views.datetime_branch")}
                </span>{" "}
                17-10-2024
              </li>
            </ul>
            <div className="mt-10 flex items-center justify-center">
              <ButtonSecondary size="large" text={t("user.views.copy")} />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};
